import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltRecorderAllToolMenuVideoWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-all-tool-menu-video-wireframe", __assign({}, transformedProps), children));
};
export default VeltRecorderAllToolMenuVideoWireframe;
